"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoCard = exports.StyledInfoCard = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledInfoCard = styled_components_1.default.div `
	text-align: left;
	padding: 20px 40px 20px 0;

	p {
		color:${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.textBlack; }};
    	font-size: ${({ theme, customStyle }) => { var _a, _b; return ((_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontSize) || theme.baseFontSize; }};
		margin: 5px;
			@media (max-width: 41em) {
				font-size: ${({ theme }) => theme.infocardContentMobile};
			}
	}

	h3 {
		margin-bottom: 0px;
	}

	span {
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
		cursor: pointer;
	}

	svg {
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
	}

	.info-card-title {
		color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
		font-weight: normal;
		font-size: ${({ theme, customStyle }) => { var _a, _b; return ((_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontSize) || theme.baseFontSize; }};
		margin: 5px;
		@media (max-width: 41em) {
			font-size: ${({ theme }) => theme.infocardTitleMobile};
		}
	}

	.edit-info-container {
			margin: 10px 5px;
			svg {
				color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
			}
			.edit-info-link {
				cursor: pointer;
				margin-left: 8px;
				color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
				font-size: ${({ theme }) => theme.baseFontSize};
				height: 20px;
				line-height: 20px;
			}
		}
	
	.change-information-container {
		padding-top: 10px;	
		svg {
			color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.hyperlink) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
		}
		a {
			margin: 0 0 0 5px;
			text-decoration: none;
			color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.hyperlink) !== null && _b !== void 0 ? _b : theme.denimBlue; }};
			cursor: pointer;
		}
	}
`;
const defaultProps = {};
const InfoCard = ({ title, children, titleClassName, titleTestId, customStyle }) => {
    return (react_1.default.createElement(exports.StyledInfoCard, { customStyle: customStyle },
        title && react_1.default.createElement("h2", { className: titleClassName ? titleClassName : 'info-card-title', "data-testid": titleTestId },
            title,
            ":"),
        children));
};
exports.InfoCard = InfoCard;
exports.InfoCard.defaultProps = defaultProps;
